
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export function useSubscriptionData(userId: string | undefined) {
  return useQuery({
    queryKey: ['subscription', userId],
    queryFn: async () => {
      if (!userId) return null;
      
      const { data, error } = await supabase
        .from('subscriptions')
        .select(`
          *,
          package:package_id (
            id,
            name,
            description,
            max_csp_accounts,
            max_trading_accounts,
            max_user_bots,
            max_premium_bots,
            max_prop_bots,
            price_monthly,
            price_yearly,
            is_popular
          )
        `)
        .eq('user_id', userId)
        .order('created_at', { ascending: false })
        .limit(1)
        .single();
      
      if (error) {
        console.error("Error fetching subscription:", error);
        return null;
      }
      
      return data;
    },
    enabled: !!userId,
  });
}
